// frontend/user/src/components/transfer-button.tsx
//
// 对应 .pen LytHR transferBtn @ bi8Au.topRow.rightActions
// context: 点击跳转 → Node ID: yOObb(页面-传输列表)
//
// 设计来源:docs/superpowers/specs/2026-05-28-transfer-entry-yOObb-design.md §3.1

import { useNavigate } from 'react-router-dom'

export function TransferButton() {
  const navigate = useNavigate()
  return (
    <button
      type="button"
      data-testid="files-header-transfer-btn"
      onClick={() => navigate('/transfers')}
      aria-label="传输列表"
      className="relative flex h-9 w-9 items-center justify-center rounded-full bg-[#F6F7F8]"
    >
      {/* lucide arrow-up-down — 对齐 .pen LytHR(左箭头朝上 / 右箭头朝下) */}
      <svg
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#1A1A1A"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="m21 16-4 4-4-4" />
        <path d="M17 20V4" />
        <path d="m3 8 4-4 4 4" />
        <path d="M7 4v16" />
      </svg>
    </button>
  )
}
